import AttendeeConstaint from 'owa-calendar-scheduling-service/lib/schema/AttendeeConstraint';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

/**
 * Create Attendee Constraints from Attendees for FML request
 */
export default function createAttendeeConstraints(
    requiredAttendees: string[],
    optionalAttendees: string[]
): AttendeeConstaint[] {
    let attendeeConstraints = [];

    if (requiredAttendees) {
        requiredAttendees.forEach(x =>
            attendeeConstraints.push({
                emailAddress: {
                    EmailAddress: x,
                } as EmailAddressWrapper,
            } as AttendeeConstaint)
        );
    }

    if (optionalAttendees) {
        optionalAttendees.forEach(x =>
            attendeeConstraints.push({
                emailAddress: {
                    EmailAddress: x,
                } as EmailAddressWrapper,
            } as AttendeeConstaint)
        );
    }

    return attendeeConstraints;
}
